import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { createApplicationFailed, createApplicationSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest, { getBodyJson } from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { CREATED } from '../../../configs/serverStatusCodes';
import {
  APPLICATION_STATUS, APPLY_METHOD_TYPE, BACKEND_URL,
} from '../../../configs';

export default function* createApplication(action) {
  try {
    const url = `${BACKEND_URL}/resources/applications`;
    const pool = action.payload;
    // pool.apply_method = APPLY_METHOD_TYPE.COMMITTEE;
    pool.status = APPLICATION_STATUS.NEW;
    const response = yield makeRequest(url, pool, action, 'POST', true);
    if (response.status === CREATED) {
      const data = yield getBodyJson(response);
      yield put(createApplicationSuccessful());
      yield call(resolveActionPromise(action, data.data));
    } else {
      const data = yield getBodyJson(response);
      yield put(createApplicationFailed());
      yield call(rejectActionPromise(action, { ...data, code: response.status }));
    }
  } catch (e) {
    yield put(createApplicationFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
